<template>
  <div class="pglist">
    <pg-header :navIndex="2"></pg-header>
    <div class="emptyData" v-if="historyList.length <= 0">
      {{ $t("common.emptyData") }}
    </div>
    <div class="pglists" v-if="historyList.length > 0">
      <div
        class="pglists-list"
        v-for="(item, index) in historyList"
        :key="index"
        @click="showDetail(item)"
      >
        <div class="gamelist-title">
          <!-- <img :src="item.game_image" alt="" /> -->
          <!-- <img src="@/assets/images/h5/bilibg.png" alt="" /> -->
          <div>
            <span> {{ item.product_name }}</span>
            <span>{{ item.order_time || "--" }}</span>
          </div>
        </div>
        <div class="gamelist-img">
          <div>{{ item.product_price + item.currency || "--" }}</div>
          <!--充值成功: #8FD7C1 {{$t("paygame.orderSuccess")}}-->
          <!-- 充值失败:#FFA0A0 {{$t("paygame.orderFailed")}}-->
          <!-- 充值中:#FFDC87 {{$t("paygame.orderPending")}}-->

          <span v-if="item.status == 1" style="background: #8FD7C1;">{{
            $t("paygame.orderSuccess")
          }}</span>
          <span v-if="item.status == 0" style="background: #FFDC87;">{{
            $t("paygame.orderPending")
          }}</span>
          <span v-if="item.status == 2" style="background: #FFA0A0;">{{
            $t("paygame.orderFailed")
          }}</span>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="paging" v-if="historyList.length > 0">
      <div class="paging-content">
        <div class="paging-content-left">
          <img
            v-show="pageNum == 1"
            src="@/assets/images/h5/icon17.png"
            alt=""
          />
          <img
            v-show="pageNum == 1"
            src="@/assets/images/h5/icon15.png"
            alt=""
          />
          <img
            @click="(pageNum = 1), getOrderList()"
            v-show="pageNum != 1"
            src="@/assets/images/h5/icon16.png"
            alt=""
          />
          <img
            v-show="pageNum != 1"
            src="@/assets/images/h5/icon14.png"
            alt=""
            @click="pageNum--, getOrderList()"
          />
        </div>
        <div class="paging-content-cont">
          <span
            :class="{ actived: item === pageNum }"
            v-for="(item, index) in displayPages"
            :key="index"
            @click="select(item, index)"
            >{{ item }}</span
          >
        </div>
        <div class="paging-content-right">
          <img
            @click="pageNum++, getOrderList()"
            v-show="pageNum < totalNum"
            src="@/assets/images/h5/icon14.png"
            alt=""
          />
          <img
            @click="(pageNum = totalNum), getOrderList()"
            v-show="pageNum < totalNum"
            src="@/assets/images/h5/icon16.png"
            alt=""
          />
          <img
            v-show="pageNum == totalNum"
            src="@/assets/images/h5/icon15.png"
            alt=""
          />
          <img
            v-show="pageNum == totalNum"
            src="@/assets/images/h5/icon17.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <h5-nav v-if="$region !== 'jp' "></h5-nav>
  </div>
</template>
<script>
import pgHeader from "./component/pgHeader.vue";
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
import h5Nav from "@/component/h5nav/komoe";
export default {
  name: "pays_h5Pgrecord",
  components: {
    pgHeader,
    h5Nav,
  },
  data() {
    return {
      gameList: [],
      distribution_region: 5,
      pageNum: 1, // 当前页码
      totalNum: 0, // 总页码
      middleSize: 3, // 中间显示几个页码
      perPageCount: 10, // 每页展示多少条数据
      historyList: [],
      main_switch_status: "",
      secondary_switch_status: "",
    };
  },
  computed: {
    // 展示页码
    ...mapGetters(["userInfo"]),
    displayPages() {
      // ① 只展示'上一页'、'页码'、'下一页'
      if (this.totalNum <= this.middleSize + 2) {
        let pages = [];
        for (let i = 1; i <= this.totalNum; i++) {
          pages.push(i);
        }
        return pages;
      } else if (this.pageNum <= this.middleSize) {
        // this.pageNum <= this.middleSize+2
        // ② 只展示右侧'...'，只要当前页码小于或者等于要展示的中间页码时就展示
        let pages = [1];
        for (let i = 2; i < this.middleSize + 1; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(this.totalNum);
        return pages;
      } else if (this.pageNum >= this.totalNum - (this.middleSize - 1)) {
        // ③ 只展示左侧'...'，主要当前页码 大于或等于 总页码-(中间要展示页码的个数 - 1)就展示
        let pages = [1, "..."];
        for (
          let i = this.totalNum - this.middleSize + 1;
          i <= this.totalNum;
          i++
        ) {
          pages.push(i);
        }
        return pages;
      } else {
        // ④ 展示左右两侧的'...'
        let pages = [1, "..."];
        // 当左右两侧的...都展示时，中间的页码该如何展示呢？其实就是 当前页码 - (中间要展示页码的个数/2向下取整) 到 当前页码 + (中间要展示页码的个数/2向下取整)即可
        const half = Math.floor(this.middleSize / 2); // 向下取整
        for (let i = this.pageNum - half; i <= this.pageNum + half; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(this.totalNum);
        return pages;
      }
    },
  },
  created() {
    if (this.$utils.getDomainName("www.komoejoy-sea.com")) {
      this.$router.push("/pay_h5/pg_record");
    }
  },
  mounted() {
    this.getSwitchStatus();
    // this.getGameList();
    // this.getOrderList();
  },
  methods: {
    // 1.获取平台充值开关状态
    getSwitchStatus() {
      const _this = this;
      this.$toast.loading({
        duration: 20000,
        message: _this.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      this.$apis.paygame.getKomoeSwitch().then(({ data }) => {
        this.$toast.clear();
        if (data.code == 0) {
          this.main_switch_status = data.data.main_switch_status;
          this.secondary_switch_status = data.data.secondary_switch_status;

          // 支付总开关和游戏充值二级菜单开关状态是否开启
          if (
            this.main_switch_status === 1 &&
            this.secondary_switch_status === 1
          ) {
            // 2.获取支持网页支付游戏信息接口

            // 判断是否登录
            // if (!this.userInfo.mid) {
            //   this.$router.push({
            //     name: "login_h5",
            //     query: { redirect: location.href },
            //   });
            //   return;
            // }
            // console.log(this.$store.state.userInfo)
            _this.getOrderList();
          } else {
            // this.$toast.clear();
            this.$router.push({ path: "/h5" });
          }
        } else {
          this.$toast.clear();
          this.$router.push({ path: "/h5" });
        }
      });
    },
    //  this.totalNum = Math.ceil(this.totalCount/parseInt(this.perPageCount));
    // 获取订单列表
    getOrderList() {
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      this.$apis.paygame
        .getKomoeOrderHistory(
          this.pageNum,
          this.perPageCount,
          3,
          Cookies.get("joy_jct")
        )
        .then(({ data }) => {
          if (data.code === 0 && data.data.total_count > 0) {
            this.totalNum = data.data.total_page;
            this.pageNum = data.data.page_number || 1;
            this.historyList = data.data.result_list;
          }
          this.$toast.clear();
        });
    },
    // 点击'页码'
    select(item, index) {
      if (typeof item === "string") {
        if (index != 1) {
          this.pageNum += 3;
          this.pageNum >= this.totalNum ? (this.pageNum = this.totalNum) : "";
        } else {
          this.pageNum -= 3;
          this.pageNum <= 0 ? (this.pageNum = 1) : "";
        }
        this.getOrderList();
        return;
      }
      if (item == this.pageNum) return;
      this.pageNum = item;
      this.getOrderList();
    },
    showDetail() {},
  },
};
</script>
<style lang="scss" scoped>
$color_fonts: #444444;
$bg_color: #50bbe5;
.pglist {
  width: 100%;
  margin-top: 1.04rem;
  min-height: calc(100vh - 2.75rem);
  height: auto;
  .emptyData {
    padding-top: 0.5rem;
    color: #b5b5b5;
    font-size: 0.16rem;
    text-align: center;
  }
  .pglists {
    width: 100%;
    height: auto;
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  .pglists-list {
    width: 92%;
    // height: auto;
    // height: 0.55rem !important;
    margin: auto;
    margin-top: 0.15rem;
    background: #fbfbfb;
    &:nth-last-of-type(1) {
      margin-bottom: 0.1rem !important;
    }
    display: flex;
    align-items: center;
    justify-content: space-between;
    .gamelist-title {
      flex: 1;
      height: auto;
      min-height: 0.44rem;
      margin-left: 0.05rem;
      display: flex;
      align-items: center;
      img {
        width: 0.44rem;
        height: 0.44rem;
        border-radius: 0.04rem;
        object-fit: cover;
      }
      > div {
        flex: 1;
        height: auto;
        min-height: 0.55rem;
        display: flex;
        flex-flow: column;
        justify-content: center;
        // margin-left: 0.13rem;

        span {
          font-size: 0.13rem;
          font-family: SourceHanSansCN;
          font-weight: bold;
          color: $color_fonts;
          &:nth-of-type(2) {
            margin-top: 0.08rem;
            font-weight: 400 !important;
            font-size: 0.11rem !important;
          }
        }
      }
    }
    .gamelist-img {
      width: auto;
      height: 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      > div {
        font-size: 0.13rem;
        font-weight: bold;
        color: $color_fonts;
      }

      span {
        padding: 0.05rem 0.1rem;
        font-size: 0.11rem;
        font-weight: 400;
        color: #ffffff;
        border-radius: 0.11rem;
      }
    }
  }
  .paging {
    width: 100%;
    height: 0.55rem;
    &-content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      &-left {
        width: 0.75rem;
        height: 100%;
        margin-right: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 0.32rem;
          height: 0.32rem;
          transform: rotate(180deg);
        }
      }
      &-cont {
        width: auto;
        // min-width: 0.3rem;
        height: 100%;
        display: flex;
        align-items: center;
        span {
          color: #d3d3d3;
          font-size: 0.16rem;
          font-weight: 500;
          margin-left: 0.05rem;
          font-weight: 400;
          &:nth-of-type(1) {
            margin-left: 0;
          }
          &.actived {
            color: $color_fonts;
          }
        }
      }
      &-right {
        width: 0.75rem;
        height: 100%;
        margin-left: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
}
</style>
